import OurProjectForm from "../component/OurProjectForm";

const OurProjectEdit = () => {
  return <OurProjectForm isEditMode={true} />;
};

export default OurProjectEdit;
